import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { distinctUntilChanged, filter, map } from "rxjs/operators";
import { ProfileService } from "../../firebase/profile.service";
import { AppState } from "../app.state";
import { clearChatUserInfoData, updateChatUserInfoData } from "./chatUserInfo.actions";
import { IChatUserInfoData, INIT_CHAT_USER_INFO_DATA } from "./chatUserInfo.state";

interface ChatUseInfoSubscriptionObject {
    [index: string]: {
        numberOfRef: number;
        subscription: Subscription;
    };
};

@Injectable({
    providedIn: 'root'
})
export class ChatUserInfoDispatcher {
    private chatUserInfoSubscriptionsObject: ChatUseInfoSubscriptionObject = {};

    constructor(
        private store: Store<AppState>,
        private profileService: ProfileService,
    ) {}

    requestForChatUserInfos(userIds: string[]) {
        userIds.forEach(userId => {
            if (this.chatUserInfoSubscriptionsObject[userId]) {
                this.chatUserInfoSubscriptionsObject[userId].numberOfRef ++;
            } else {
                this.chatUserInfoSubscriptionsObject[userId] = {
                    subscription: this.creatChatUserInfoSubscription(userId),
                    numberOfRef: 1,
                }
            }
        });
    }

    getChatUserInfoObservable(userId: string): Observable<IChatUserInfoData> {
        return this.store.select('chatUserInfos').pipe(
            map(chatUserInfos => chatUserInfos[userId]),
            filter(chatUserInfo => chatUserInfo !== undefined),
            distinctUntilChanged(),
        );
    }

    clearRequestForChatUserInfos(userIds: string[]) {
        userIds.forEach(userId => {
            if (this.chatUserInfoSubscriptionsObject[userId]) {
                this.chatUserInfoSubscriptionsObject[userId].numberOfRef --;
            } else {
                console.error(`[Clear Request] Request for user id: ${userId} - NOT EXIST!`);
            }
        });

        Object.keys(this.chatUserInfoSubscriptionsObject).forEach(key => {
            if (this.chatUserInfoSubscriptionsObject[key].numberOfRef < 1) {
                if (this.chatUserInfoSubscriptionsObject[key].subscription)
                    this.chatUserInfoSubscriptionsObject[key].subscription.unsubscribe();
                this.store.dispatch(clearChatUserInfoData({userId: key}));
                delete this.chatUserInfoSubscriptionsObject[key];
            }
        }); 
    }

    private creatChatUserInfoSubscription(userId: string): Subscription {
        return this.profileService.getPublicUserInfoObservable(userId).subscribe(
            profileData => {
                const avatarData: IChatUserInfoData = {...INIT_CHAT_USER_INFO_DATA};
                avatarData.displayName = profileData.displayName;
                avatarData.useNftAsAvatar = profileData.useNftAsAvatar;
                avatarData.photoUrl = profileData.photoURL;
                if (profileData.nft && profileData.nft.imageUrl)
                    avatarData.nftUrl = profileData.nft.imageUrl;
                if (profileData.nft && profileData.nft.usingCroppedImage) {
                    avatarData.usingCroppedImage = true;
                    if (profileData.nft.croppedImageUrl)
                        avatarData.croppedImageUrl = profileData.nft.croppedImageUrl;
                }
                avatarData.shortId = profileData.shortID;
                this.store.dispatch(updateChatUserInfoData({userId, chatUserInfoData: avatarData}));
            }
        )
    }
}